import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=4d498d58&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=4d498d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d498d58",
  null
  
)

export default component.exports